{
    "title": "Counterparties",
    "board": {
        "name": "Name",
        "status": "Status",
        "type": "Type",
        "country": "Country",
        "rail": "Rail"
    },
    "counterparty":{
        "general": "General Information",
        "bankinformation": "Bank Information"
    },
    "fields": {
        "id": "Layer2 Counterparty Unique Identifier",
        "customerid": "Izzi Wallet Customer which created the Counterparty Unique Identifier",
        "rail": "Counterparty Transaction Rail (Fedwire, Swift, ACH, etc.)",
        "type": "Layer2 Counterparty Type based on location/asset",
        "customername": "Izzi Wallet customer which created the Counterparty first name (registered name or first name)",
        "customername2": "Izzi Wallet customer which created the Counterparty second name (trading name or last name) ",
        "counterpartyname": "Destinator Counterparty Name",
        "counterpartytype": "Entity type",
        "counterpartyrelationship": "Relationship type between Izzi client and the recipient",
        "counterpartyaddress": "Recipient's Address",
        "counterpartycountry": "Recipient's Country",
        "counterpartyaddress1": "Recipient's Address Line 1",
        "counterpartyaddress2": "Recipient's Address Line 2",
        "counterpartycity": "Recipient's City",
        "counterpartystate": "Recipient's State",
        "counterpartyzipcode": "Recipient's Zip Code",
        "counterpartybankname": "Recipient's Bank Name",
        "counterpartybankaddress": "Recipient's Bank Address",
        "counterpartybankcountry": "Recipient's Bank Country",
        "counterpartybankaddress1": "Recipient's Bank Address Line 1",
        "counterpartybankaddress2": "Recipient's Bank Address Line 2",
        "counterpartybankcity": "Recipient's Bank City",
        "counterpartybankstate": "Recipient's Bank State",
        "counterpartybankzipcode": "Recipient's Bank Zip Code",
        "counterpartyaccountnumber": "Recipient's Account Number",
        "counterpartyiban": "Recipient's IBAN",
        "counterpartyswift": "Recipient's SWIFT BIC",
        "counterpartyroutingnumber": "Recipient's Routing Number",
        "counterpartywalletaddress": "Recipient's Wallet Address",
        "counterpartywallettype": "Recipient's Wallet Type"
    }
}